import {
  Badge,
  cn,
  Icon,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@nexus/ui";

import type { OpportunityHubSelectionLevel } from "./hub-chrome-selection.js";
import { OpportunityHubNameList } from "./OpportunityHubNameList.js";
import {
  HUB_SELECTION_LEVEL_ICON,
  HUB_SLATE_CHIP_CLASS,
} from "./OpportunityHubSelectionPill.js";

const TOOLTIP_DELAY_MS = 300;

const SCOPE_PILL_CLASS = cn(HUB_SLATE_CHIP_CLASS, "max-w-[16rem]");

/**
 * Upstream scope on a hub tab, styled like the selection pill. It sits inside the
 * tab trigger, so it stays a span. Hovering lists the scoping items by name.
 */
export function OpportunityHubScopePill({
  level,
  label,
  names = [],
  total,
}: {
  level: OpportunityHubSelectionLevel;
  label: string;
  /** Names of the scoping items that have loaded. No tooltip when empty. */
  names?: readonly string[];
  /** Scoping items, named or not. */
  total?: number;
}) {
  const pill = (
    <Badge variant="slate" className={SCOPE_PILL_CLASS}>
      <Icon name={HUB_SELECTION_LEVEL_ICON[level]} size="xs" color="inherit" aria-hidden />
      <span className="min-w-0 truncate">{label}</span>
    </Badge>
  );
  if (names.length === 0) return pill;

  return (
    <TooltipProvider delayDuration={TOOLTIP_DELAY_MS}>
      <Tooltip>
        <TooltipTrigger asChild>{pill}</TooltipTrigger>
        <TooltipContent align="start" className="px-3 py-2">
          <OpportunityHubNameList names={names} total={total} />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
